import { render, staticRenderFns } from "./handwrite.vue?vue&type=template&id=665ffe14&scoped=true&"
import script from "./handwrite.vue?vue&type=script&lang=js&"
export * from "./handwrite.vue?vue&type=script&lang=js&"
import style0 from "./handwrite.vue?vue&type=style&index=0&id=665ffe14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665ffe14",
  null
  
)

export default component.exports